import React, { useEffect } from 'react'

import { useField } from 'formik'
import { DateFormat, DateRangeSelect } from './StatsDateRange'
import { AvailableGranularity, StatsToolbarFilterField } from './StatsFilters'
import dayjs from 'dayjs'
import DateField from '../../form/DateField'

export const Dates = (): JSX.Element => {
  const [, { value: startDate }] = useField<string>({ name: 'startDate' })
  const [, { value: endDate }, { setValue: setEndDate }] = useField<string>({
    name: 'endDate',
  })

  useEffect(() => {
    if (dayjs(startDate).isAfter(dayjs(endDate))) setEndDate(startDate, false)
  }, [startDate])

  return (
    <>
      <StatsToolbarFilterField>
        <DateField name="startDate" label={'commons.startDate'} valueFormat={DateFormat} variant="outlined" />
      </StatsToolbarFilterField>
      <StatsToolbarFilterField>
        <DateField
          name="endDate"
          label={'commons.endDate'}
          valueFormat={DateFormat}
          minDate={dayjs(startDate)}
          variant="outlined"
        />
      </StatsToolbarFilterField>
    </>
  )
}

export const StatsDateFilter = ({ withGranularity }: { withGranularity: boolean }): JSX.Element => {
  return (
    <>
      <StatsToolbarFilterField>
        <DateRangeSelect />
      </StatsToolbarFilterField>

      <Dates />

      {withGranularity && (
        <StatsToolbarFilterField>
          <AvailableGranularity />
        </StatsToolbarFilterField>
      )}
    </>
  )
}

export default StatsDateFilter
